import * as types from "./actionTypes"

const initialState = {
    error: {},
}

export default function errorReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        case types.CLEAR_ERROR:
            return {
                ...state,
                error: {},
            }

        default:
            return state
    }
}
